// extracted by mini-css-extract-plugin
module.exports = {"root":"ShowIfInScreen_root__10o42","frombottom":"ShowIfInScreen_frombottom__14ZGt","fadein":"ShowIfInScreen_fadein__My5rS","hidden":"ShowIfInScreen_hidden__30weM"};